<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ this.user_name ?this.user_name : "unknown" }}
          <!-- <b class="caret"></b> -->
        </span>
      </a>

      <!-- <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <a href="#user/info">
                  <span class="sidebar-mini">{{$I18n("personal_info_mini")}}</span>
                  <span class="sidebar-normal">{{$I18n("personal_info")}}</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition> -->
    </div>
  </div>
</template>
<script>
// import { CollapseTransition } from "vue2-transitions";

export default {
  components: {
    // CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: "Tania Andrew",
    },
    rtlTitle: {
      type: String,
      default: "تانيا أندرو",
    },
    avatar: {
      type: String,
      default: "../img/faces/user.png",
    },
  },
  data() {
    return {
      user_name : this.UserInfo.user_name,
      isClosed: true,
    };
  },
  methods: {
    clicked: function (e) {
      e.preventDefault();
    },
    toggleMenu: function () {
      this.isClosed = !this.isClosed;
    },
  },
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
